import React from "react";
import ContratItem from "./ContractItem";
import CardsList from "../UI/CardsList/CardsList";
import "./ListContracts.scss";
import Card from "../UI/Card/Card";
import CardTask from "../CardTask/CardTask";

export default function ListContracts(props) {
  const contracts = props.contracts;
  function getContractHandler(id, p) {
    props.onGetContract(id, p);
  }
  return (
    <CardsList>
      {contracts.map((contract) => (
        <ContratItem
          key={contract.id}
          contract={contract}
          onGetContract={getContractHandler}
        />
      ))}
      {contracts.length == 0 && <span>Ничего нет</span>}
    </CardsList>
  );
}